"use client";

import { ArrowUp, Settings } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { glassCardVariants } from "@/components/creations/glass-card";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { useVisionBoardPreferences } from "@/hooks/use-board";
import { useTheme } from "next-themes";

export function NavUtils({ isCollapsed }: { isCollapsed: boolean }) {
  const { isVisible, toggleVisibility } = useVisionBoardPreferences();
  const { resolvedTheme } = useTheme();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger>
          <div className="hover:text-primary hover:cursor-pointer group flex items-center gap-2 ">
            <Settings className="size-5 shrink-0 group-hover:animate-spin" />
            {!isCollapsed && <span>Settings</span>}
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          className={glassCardVariants({
            className: "border-none mt-4 p-4 flex flex-col gap-2",
          })}
        >
          {/* <DropdownMenuItem onClick={toggleVisibility}>
            {isVisible ? (
              <ArrowUp className="size-5 text-foreground" />
            ) : (
              <ArrowUp className="size-5 rotate-180 text-foreground" />
            )}
            <span>{isVisible ? "Hide Board" : "Show Board"}</span>
          </DropdownMenuItem> */}
          {/* <DropdownMenuItem>
            <Info className="size-5 mr-2" />
            <span>More</span>
          </DropdownMenuItem> */}

          <ThemeToggle
            variant="transparent"
            text={resolvedTheme === "light" ? "Light Mode" : "Dark Mode"}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
